export default "__VITE_ASSET__Cl7bmL57__"